<template>
    <div class="flex flex-wrap py-2">
        <div class="w-full px-4">
            <nav class="relative flex flex-wrap items-center justify-between px-2 py-3 bg-primary-default rounded">
                <div class="w-full px-4 mx-auto flex flex-wrap items-center justify-between">
                    <div class="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
                        <router-link
                            :to="'/'" class="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white">
                            BDEW Heizkostenvergleich {{ loggedIn ? '(logged in)' : '' }}
                        </router-link>
                        <button class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none" type="button" v-on:click="toggleNavbar()">
                            <span class="block relative w-6 h-px rounded-sm bg-white"></span><span class="block relative w-6 h-px rounded-sm bg-white mt-1"></span><span class="block relative w-6 h-px rounded-sm bg-white mt-1"></span>
                        </button>
                    </div>
                    <div v-bind:class="{'hidden': !menuShow, 'flex': menuShow}" class="lg:flex lg:flex-grow items-center">
                        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
                            <template v-for="link in getLinks()">
                                <router-link
                                    :to="link.to"
                                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                                    custom
                                >
                                    <li class="nav-item" v-if="checkLink(route)" @click="this.menuShow = false">
                                        <a class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug transition duration-500 ease-in-out  hover:opacity-75" :class="[isActive || isExactActive ? activeClass : 'text-white']" :href="href" @click="navigate">
                                            {{ link.name }}
                                        </a>
                                    </li>
                                </router-link>
                            </template>
                            <li class="nav-item" v-if="loggedIn" @click="this.menuShow = false">
                                <a class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug transition duration-500 ease-in-out  hover:opacity-75 text-white cursor-pointer"  @click="logout()">
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import {useStore} from "vuex";
import {useRouter} from 'vue-router'
import {computed, getCurrentInstance, ref} from 'vue';
import {API} from "@/utils/api";

export default {
    props: {
        links: Object
    },
    data() {
        return {
            menuShow: false,
            activeClass: 'text-black'
        }
    },
    methods: {
        toggleNavbar: function () {
            this.menuShow = !this.menuShow;
        }
    },
    setup (props) {

        const links = props.links;
        const store = useStore();
        const router = useRouter();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn'])
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const getLinks = () => {
            return links;
        }

        const checkLink = (route) => {
            if(route.meta){
                if(route.meta.onlyGuest && loggedIn.value || route.meta.requiresAuth && !loggedIn.value){

                    return false;
                }
            }
            return true;
        }

        const logout = () => {
            API.post('logout', {}).then((resp) => {
                store.dispatch('Customer/logout').then(function(){

                    emitter.emit("flash-message", {
                        text: 'logged out successfully',
                        type: 'success'
                    })
                    router.push( '/')
                }).catch(err => console.error(err))
            }).catch(err => {
                console.error(err)
            })

        }

        return {
            loggedIn,
            getLinks,
            checkLink,
            logout
        }
    }
}
</script>
